import { render, staticRenderFns } from "./EndUserAgreement.vue?vue&type=template&id=84dea066&scoped=true&"
import script from "./EndUserAgreement.vue?vue&type=script&lang=js&"
export * from "./EndUserAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dea066",
  null
  
)

export default component.exports